import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store/index';
import index from './index.vue'
import ProductsExchanges from './components/ProductsExchanges.vue';
import ContractDetails from './components/ContractDetails.vue';
import ProductResults from './components/ProductResults.vue';

const routes = [
    {
        path: '/', component: ProductsExchanges
    },
    {
        path: '/:tab', component: ProductsExchanges
    },
    {
        path: '/:tab/region/:region', component: ProductsExchanges
    },
    {
        path: '/product/:type', component: ProductsExchanges
    },
    {
        path: '/product/:type/region/:region', component: ProductsExchanges
    },
    {
        path: '/exchange/:exchId', component: ProductResults
    },
    {
        path: '/contractdetails/:conid/:type', component: ContractDetails
    },
    {
        path: '/*', redirect: '/'
    }
];

const router = new VueRouter({
    mode: "hash",
    hashbang: true,
    history: true,
    scrollBehavior (to, from, saved) {
        return { x: 0, y: 0}
    },
    routes
});

router.afterEach((to, from) => {
    window.scrollTo(0, 0);
});

const app = new Vue({router, store, ...index});

if (window.AUTO_MOUNT !== false) {
    const appEl = document.getElementById('app');
    if (appEl){
        app.$mount('#app');
    }
}

window.productsapp = app;
